import { format } from "date-fns";

export interface CreatedByProps {
  createdBy: string | null;
  created: string | null;
}

const CreatedBy: React.FC<CreatedByProps> = ({
  createdBy = null,
  created = null,
}) =>
  createdBy ? (
    <div>
      {createdBy && (
        <p id="alert-created-by">
          {L.ALERT_CREATED_BY} {createdBy}{" "}
          {created && format(created, "yyyy-MM-dd HH:mm")}
        </p>
      )}
    </div>
  ) : null;

export default CreatedBy;
